import { useState, useRef, useEffect } from "react";

interface AddDropdownItem {
  label: string;
  onClick: () => void;
}

interface AddDropdownProps {
  items: AddDropdownItem[];
  /** Style the trigger to match its surroundings — the boarding-pass card
   *  passes its own round button class instead of the page FAB. */
  triggerClassName?: string;
}

export function AddDropdown({ items, triggerClassName = "btn btn-fab" }: AddDropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [open]);

  return (
    <div className="add-dropdown" ref={ref}>
      <button
        type="button"
        className={triggerClassName}
        onClick={() => setOpen(!open)}
        aria-label="Add"
        title="Add"
      >
        <span className={`btn-fab-icon ${open ? "btn-fab-icon-active" : ""}`}>+</span>
      </button>
      {open && (
        <div className="add-dropdown-menu">
          {items.map((item) => (
            <button
              key={item.label}
              className="add-dropdown-item"
              onClick={() => {
                item.onClick();
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
